// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9274bef","455":"380e03c3","977":"260b0b5a"}[chunkId] + ".chunk.js";
};